import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";

export default async function GetBanked(salesOrg: string, customerNum: string) {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg,
      customerNum,
    },
    url: `${BASE_URL}/api/bank`,
  };

  return await AXIOS_INSTANCE(config).then((v) => v.data);
}
